import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BusinessForwardSearchItem } from 'components/business';
import {Businesses} from 'base/api';
import ReactPaginate from 'react-paginate';
import { ShowIf, NoContent } from 'components/utils';
import _ from 'lodash';

class BusinessForwardSearchList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      businesses: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      selected: 0,
      searchTerm: '',
      isSearched: false,
      isLoading: false
    }

    this.handleChoose = this.handleChoose.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.postLoadBusinesses = this.postLoadBusinesses.bind(this);
    this.loadBusinessesFromServer = this.loadBusinessesFromServer.bind(this);
  }

  static propTypes = {
    onChoose: PropTypes.func.isRequired,
    limit: PropTypes.number
  }

  static defaultProps = {
    limit: 10
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listBusinesses != this.state.listBusinesses) {
      this.setState({isLoading: true}, () => {
        this.setState({
          businesses: nextProps.listBusinesses
        }, () => {
          this.setState({isLoading: false});
        });
      })
    }
  }

  handleSearch(e) {
    let value = e.target.value;

    this.setState({
      isLoading: true
    }, () => {
      this.setState({
        searchTerm: value,
        isSearched: true
      }, () => {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
          this.loadBusinessesFromServer();
        }, 1000);
      });
    });
  }

  loadBusinessesFromServer() {
    Businesses.actions.search.request({
      limit: this.props.limit,
      offset: this.state.offset,
      q: this.state.searchTerm
    }).then(res => {
      this.postLoadBusinesses(res.data);
    });
  }

  postLoadBusinesses =(data) => {
    if (!data) {
      return;
    }

    this.props.dispatch({
      type: 'UPDATE_BUSINESSES_LIST',
      businesses: data.results
    });

    let total = data.total || 0;
    let pageCount = Math.ceil(total / this.props.limit);
    this.setState({pageCount, total});
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({offset, selected}, () => {
      this.loadBusinessesFromServer();
    });
  };

  handleChoose = (id) => {
    const business = _.find(this.state.businesses, item => item.id === id);
    if (!id || !business) {
      return;
    }

    let businessResult = {
      ...{},
      id: id,
      logo: business.logo,
      name: business.name,
      phone: business.phone,
      email: business.email,
    };

    this.props.onChoose && this.props.onChoose(businessResult);
  }

  render() {
    const { isLoading, isSearched, businesses, searchTerm, pageCount, selected } = this.state;
    return (
      <div className="content">
        <div className="form-group">
          <label>Lọc doanh nghiệp theo tên</label>
          <input type="text" className="form-control" value={searchTerm} placeholder="Business Name" onChange={this.handleSearch.bind(this)}/>
        </div>
        <ShowIf condition={isLoading || (businesses && businesses.length === 0)}>
          <NoContent
            content={
              isLoading ? 'Đang tải dữ liệu...' : (
                isSearched ? 'Không có kết quả nào' : 'Hãy lọc doanh nghiệp theo tên'
              )
            }
            height={300}
          />
        </ShowIf>
        <ShowIf condition={!isLoading && businesses && businesses.length > 0}>
          <table className="table table-striped businesses-forward-table">
            <thead className="thead">
              <tr className="tr-head">
                <th scope="col" className="col-lg-1">
                  #
                </th>
                <th scope="col" className="col-lg-8">
                  Doanh nghiệp
                </th>
                <th scope="col" className="col-lg-3 text-center">
                  Hành động
                </th>
              </tr>
            </thead>
            <tbody className="tbody">
              {businesses.map((business, i) => (
                <BusinessForwardSearchItem
                  key={i}
                  data={business}
                  index={(i + 1 + ((selected) * this.props.limit))}
                  onChoose={this.handleChoose}
                  isCanNotChoose={_.indexOf(this.props.disabledIdList, business.id) !== -1}/>
              ))}
            </tbody>
          </table>
        </ShowIf>
        <ShowIf condition={businesses && businesses.length > 0}>
          <ReactPaginate previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  listBusinesses: state.listBusinesses
});

export default connect(mapStateToProps)(BusinessForwardSearchList);


// WEBPACK FOOTER //
// ./components/business/BusinessForwardSearchList.jsx